import { UnderConstructionPage } from "./UnderConstruction"

export const Contact = () => {
    return (
        <UnderConstructionPage />
    )
}